<template>
    <div id="main">
        <div class="page">
            <div class="exportacao-detalhes vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("exportacao-detalhes") }} :
                            {{ exportacao.idexportacao }} -
                            {{ exportacao.titulo }} - {{ user }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a>{{
                                        isVenda
                                            ? $t("vendas")
                                            : $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a>{{ $t("exportacao-dados") }}</a>
                                </li>
                                <li>
                                    <a href="#" aria-current="page">{{
                                        $t("exportacao-detalhescam")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div
                    class="
                        columns
                        is-2 is-variable is-multiline
                        control-bar
                        mt-0
                    "
                >
                    <div
                        v-if="exportacao.datahorasolicitacao"
                        class="status-export"
                    >
                        <b-tag
                            :type="statusColor('EXECUTANDO')"
                            class="export-dados"
                        >
                            {{ "Exportando" }}
                            <br />
                            {{
                                exportacao.datahorasolicitacao | moment("L LTS")
                            }}
                        </b-tag>
                    </div>
                    <div
                        v-if="exportacao.datahoradisponivel"
                        class="status-export"
                    >
                        <b-tag
                            :type="statusColor('FINALIZADA')"
                            class="export-dados"
                        >
                            {{ "Finalizada" }}
                            <br />
                            {{
                                exportacao.datahoradisponivel | moment("L LTS")
                            }}
                        </b-tag>
                    </div>
                    <div
                        v-if="exportacao.datahoraexcluido"
                        class="status-export"
                    >
                        <b-tag
                            :type="statusColor('EXCLUIDA')"
                            class="export-dados"
                        >
                            {{ "Excluída" }}
                            <br />
                            {{ exportacao.datahoraexcluido | moment("L LTS") }}
                        </b-tag>
                    </div>
                </div>
                <div class="exportacao-table registry-wrapper">
                    <container-loader
                        v-if="isLoading && !$store.getters.isLoading"
                    />
                    <b-table
                        class="data-table"
                        :data="exportacao ? exportacao.logs : []"
                        backend-pagination
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.label != '' ? $t(f.label) : ''"
                            :width="f.width"
                            :centered="f.centered"
                            v-slot="props"
                        >
                            <template slot="header">
                                <span>
                                    {{ f.label ? $t(f.label) : "-" }}
                                </span>
                            </template>

                            <div v-if="f.key == 'processo'">
                                <span v-if="props.row.acao">
                                    <pre>{{
                                        props.row.acao ? props.row.acao : "—"
                                    }}</pre>
                                </span>
                            </div>
                            <div v-else-if="f.key == 'solicitante'">
                                {{
                                    props.row.usuario
                                        ? props.row.usuario.nome
                                        : "-"
                                }}
                            </div>
                            <div v-else-if="f.key == 'datahorainc'">
                                {{
                                    props.row.datahorainc
                                        ? $moment(props.row.datahorainc).format(
                                              "L LTS"
                                          )
                                        : "-"
                                }}
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <b-pagination
                        order="is-centered"
                        :total="totalRows"
                        :current.sync="currentPage"
                        :per-page="perPage"
                        @change="carregarDados"
                    />
                </div>
            </div>
            <div class="form-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="$router.go(-1)"
                >
                    {{ $t("voltar") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ExportacaoService from "@/services/ExportacaoService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            exportacao: {
                logs: [],
            },
            service: new ExportacaoService(this.$http, this.$router),
            fields: [
                { key: "solicitante", label: "solicitante", sortable: false },
                { key: "processo", label: "processo", sortable: false },
                { key: "datahorainc", label: "data-hora", sortable: false },
                {
                    key: "destino",
                    label: "destino",
                    sortable: false,
                    width: 250,
                    centered: true,
                    vcenter: true,
                },
            ],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            isLoading: false,
            query: "",
            tipo: "h",
            sort: "titulo",
            order: "asc",
            ini: null,
            fim: null,
            delete: null,
            pageId: 0,
            user: "",
            isVenda: "vendas" === this.$route.meta.contexto ? true : false,
        };
    },
    created() {
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.pageId = this.$route.params.id;
        this.carregarDados();
    },
    methods: {
        carregarDados() {
            this.isLoading = true;

            this.service
                .findById(this.pageId)
                .then((r) => {
                    this.exportacao = r.content;
                    this.user = this.exportacao.usuario
                        ? this.exportacao.usuario.nome
                        : "";
                })
                .catch((e) => {
                    console.error("Erro ao carregar exportações.");
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarOrigens(q) {
            // this.usuariosLoading = true;
            // this.colaboradorService.findListAssociated(q)
            //     .then(r => {
            //         this.usuarios = r.content;
            //     })
            //     .catch(e => {
            //         console.error(`Erro ao realizar pesquisa de colaboradores. Termo: [${q}]`, e);
            //     })
            //     .finally(_ => {
            //         this.usuariosLoading = false;
            //     });
        },
        onSearch(value) {
            this.query = this.removeAcentos(value);
            this.currentPage = 1;
            this.carregarDados();
        },
        statusColor(s) {
            switch (s.toUpperCase()) {
                case "FINALIZADA":
                    return "is-success";
                case "EXECUTANDO":
                    return "is-warning";
                default:
                    return "is-danger";
            }
        },
        handleDateChange(nova_data, campo) {
            switch (campo) {
                case "inicio":
                    this.filtros.ini =
                        this.$moment(nova_data).format("YYYY-MM-DD");
                    break;
                case "fim":
                    this.filtros.fim =
                        this.$moment(nova_data).format("YYYY-MM-DD");
                    break;
            }
        },
    },
};
</script>


<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .exportIcons {
            display: flex;
        }

        .export-icon {
            color: var(--primary-color);
        }

        .status-export {
            padding: 10px;
        }

        .export-dados {
            padding: 30px;
            text-align: center;
        }

        .control-bar {
            margin-bottom: 0;

            .column:first-child {
                padding-bottom: 0.25rem;
            }

            .column:last-child {
                padding-top: 0.25rem;
            }

            .date-opts {
                margin-bottom: 0.5rem !important;
            }

            .date-group {
                justify-content: center;
                flex-wrap: wrap;
            }
        }
    }
}
</style>